// ============================================================
// cart-localstorage.js — Persistance panier via localStorage
// Non-invasif : se branche sur PUB_SUB_EVENTS existant
// ============================================================

(function () {
  const STORAGE_KEY = 'zwiller_cart_backup';
  const STORAGE_EXPIRY_KEY = 'zwiller_cart_backup_expiry';
  const USER_CLEARED_KEY = 'zwiller_cart_user_cleared';
  const RESTORE_ATTEMPTED_KEY = 'zwiller_cart_restore_attempted';
  const EXPIRY_DAYS = 7; // Panier conservé 7 jours

  // --- Sauvegarde ---
  function saveCart(cartData) {
    if (!cartData || !Array.isArray(cartData.items)) return;

    // Un panier vide n'est pas une sauvegarde : on efface le backup, sinon il
    // ressusciterait les articles que le client vient de retirer.
    if (cartData.items.length === 0) {
      clearSavedCart();
      return;
    }

    try {
      const expiry = Date.now() + EXPIRY_DAYS * 24 * 60 * 60 * 1000;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(cartData.items));
      localStorage.setItem(STORAGE_EXPIRY_KEY, expiry);
    } catch (e) {
      console.warn('[CartLS] Impossible de sauvegarder le panier:', e);
    }
  }

  // --- Lecture ---
  function getSavedCart() {
    try {
      const expiry = localStorage.getItem(STORAGE_EXPIRY_KEY);
      if (expiry && Date.now() > parseInt(expiry)) {
        clearSavedCart();
        return null;
      }
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : null;
    } catch (e) {
      return null;
    }
  }

  // --- Suppression ---
  function clearSavedCart() {
    try {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(STORAGE_EXPIRY_KEY);
    } catch (e) {
      /* stockage indisponible */
    }
  }

  // --- Vidage volontaire du panier par le client ---
  // Appelé par le bouton « Vider le panier ». Le drapeau survit au reload et
  // interdit toute restauration pour la session en cours.
  function markUserCleared() {
    clearSavedCart();
    try {
      sessionStorage.setItem(USER_CLEARED_KEY, '1');
    } catch (e) {
      /* stockage indisponible */
    }
  }

  function hasUserCleared() {
    try {
      return sessionStorage.getItem(USER_CLEARED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  // Une seule tentative de restauration par session : si un article est devenu
  // indisponible, /cart/add.js échoue et la page ne doit pas boucler.
  function restoreAlreadyAttempted() {
    try {
      return sessionStorage.getItem(RESTORE_ATTEMPTED_KEY) === '1';
    } catch (e) {
      return true;
    }
  }

  function markRestoreAttempted() {
    try {
      sessionStorage.setItem(RESTORE_ATTEMPTED_KEY, '1');
    } catch (e) {
      /* stockage indisponible */
    }
  }

  // --- Restauration ---
  async function restoreCart(savedItems) {
    markRestoreAttempted();

    try {
      // Vérifier que le panier Shopify est bien vide
      const response = await fetch('/cart.js');
      const currentCart = await response.json();
      if (currentCart.item_count > 0) return; // Panier déjà actif, on ne touche pas

      // Préparer les items à restaurer (propriétés et abonnements conservés)
      const items = savedItems
        .map((item) => {
          const payload = { id: item.variant_id || item.id, quantity: item.quantity };
          if (item.properties && Object.keys(item.properties).length) payload.properties = item.properties;
          const sellingPlanId = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id;
          if (sellingPlanId) payload.selling_plan = sellingPlanId;
          return payload;
        })
        .filter((item) => item.id && item.quantity > 0);

      if (items.length === 0) {
        clearSavedCart();
        return;
      }

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!addResponse.ok) {
        // Articles indisponibles ou panier refusé : le backup est inexploitable.
        clearSavedCart();
        return;
      }

      // Recharger la page pour afficher le panier restauré
      window.location.reload();
    } catch (e) {
      console.warn('[CartLS] Impossible de restaurer le panier:', e);
      clearSavedCart();
    }
  }

  // --- Détection d'une commande postérieure à la sauvegarde ---
  // window.ZwillerLastOrderAt (layout/theme.liquid) : date en secondes de la
  // dernière commande du client connecté, 0 sinon. La date de sauvegarde se
  // déduit de l'expiration (sauvegarde + EXPIRY_DAYS).
  function backupPredatesLastOrder() {
    const lastOrderAt = Number(window.ZwillerLastOrderAt) * 1000;
    if (!lastOrderAt) return false;
    try {
      const expiry = parseInt(localStorage.getItem(STORAGE_EXPIRY_KEY));
      if (!expiry) return false;
      const savedAt = expiry - EXPIRY_DAYS * 24 * 60 * 60 * 1000;
      return lastOrderAt >= savedAt;
    } catch (e) {
      return false;
    }
  }

  // --- Branchement sur PUB_SUB_EVENTS ---
  function init() {
    // Écouter les mises à jour du panier via le système existant
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event && event.cartData) {
          saveCart(event.cartData);
        }
      });
    }

    // Vider le backup quand une commande est passée
    if (window.location.pathname.includes('/thank_you') || window.location.pathname.includes('/orders/')) {
      clearSavedCart();
      return;
    }

    // Commande passée depuis la dernière sauvegarde : la page de confirmation
    // est hors thème, donc le backup n'a pas été purgé. Le restaurer
    // recréerait dans le panier les articles d'une commande déjà validée.
    if (backupPredatesLastOrder()) {
      clearSavedCart();
      return;
    }

    // Au chargement : restaurer si panier vide, sauf vidage volontaire du client
    if (hasUserCleared() || restoreAlreadyAttempted()) return;

    const saved = getSavedCart();
    if (!saved || saved.length === 0) return;

    // Attendre que Shopify soit prêt
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        if (cart.item_count === 0) {
          restoreCart(saved);
        }
      })
      .catch(() => {});
  }

  // API publique : utilisée par le bouton « Vider le panier »
  window.ZwillerCartBackup = {
    save: saveCart,
    clear: clearSavedCart,
    markUserCleared: markUserCleared,
  };

  // Attendre que le DOM et les scripts du thème soient prêts
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
